import React from "react";
import { Helmet } from "react-helmet";
import Layout from "../../components/layout";
import { ReduxConnect } from "../../../toolkit/decorators/Artifact";
import {
  TotalPassListDispatcher,
  totalPassListDispatcher
} from "./TotalPassList.dispatcher";
import { TotalPassListStore, totalPassListStore } from "./TotalPassList.store";
import TotalPassListComponent from "../../components/totalPassList";

interface Props extends TotalPassListStore, TotalPassListDispatcher {}

interface State {}

@ReduxConnect(totalPassListStore, totalPassListDispatcher)
export default class TotalPassListContainer extends React.Component<
  Props,
  State
> {
  render() {
    return (
      <main>
        <Layout>
          <Helmet title="Empresas de convenio" />
          <TotalPassListComponent {...this.props} />
        </Layout>
      </main>
    );
  }
}
